<mat-dialog-content>
    <h2 mat-dialog-title>{{ 'LiveVoting.Title' | translate }}</h2>
    <div class="items">
        @for (item of currentVoting(); track item.gmAgendaItemNumber) {
            @if (!item.parentGmAgendaItemNumber) {
                <div class="agenda-item">
                    <!-- when iterating the array just ignore children, we only care about items who are parents or have no relationship -->
                    <div>
                        <h3>{{ item.number }} - {{ item.description }}</h3>
                    </div>

                    @if (!hasChildren(item)) {
                        <!-- if it has no children just display the voting buttons -->
                        <ng-container *ngTemplateOutlet="votingButtons; context: { item: item }" />
                    } @else {
                        <!-- if it has children show no buttons for parent and create a card for each child with buttons  -->
                        <div class="children">
                            @for (child of getChildren(item); track child.gmAgendaItemNumber) {
                                <div class="child">
                                    <div>
                                        <h4>{{ child.number }} - {{ child.description }}</h4>
                                    </div>
                                    <div>
                                        <ng-container *ngTemplateOutlet="votingButtons; context: { item: child }" />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        } @empty {
            <div class="no-voting-items">
                @if (isLoading()) {
                    <mat-spinner [diameter]="32" />
                } @else {
                    {{ 'LiveVoting.NoActiveVoting' | translate }}
                }
            </div>
        }
    </div>
</mat-dialog-content>

<ng-template #votingButtons let-item="item">
    <div class="voting-buttons" [class.user-voted]="item.vote">
        <button
            mat-stroked-button
            (click)="vote(item, VoteOptionEnum.Yes)"
            class="positive"
            [class.selected]="item.vote === +VoteOptionEnum.Yes">
            <span class="material-icons mr-3">check</span>
            {{ 'Voting.Yes' | translate }}
        </button>
        <button
            mat-stroked-button
            (click)="vote(item, VoteOptionEnum.No)"
            class="negative"
            [class.selected]="item.vote === +VoteOptionEnum.No">
            <span class="material-icons mr-3">close</span>
            {{ 'Voting.No' | translate }}
        </button>
        <button
            mat-stroked-button
            (click)="vote(item, VoteOptionEnum.Abstention)"
            class="neutral"
            [class.selected]="item.vote === +VoteOptionEnum.Abstention">
            <span class="material-icons mr-3">remove</span>
            {{ 'Voting.Abstain' | translate }}
        </button>
    </div>
</ng-template>
